import { EmptyTextData } from 'library/types';

export const isIsoHullId = (id: EmptyTextData) => id === 'ISO 10087';

export const isUsCoastGuardHullId = (id: EmptyTextData) =>
	id === 'US Coast Guard';
